import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, RequestMethod } from '@angular/http';
import 'rxjs/add/operator/map';

import { Cookie } from 'ng2-cookies';
import { JwtService } from '../../jwt/jwt.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ImageModel } from '../model/image.model';
import { HttpInterceptor } from '../interceptor/http-interceptor';
import { PosterRequest } from '../../poster/poster-request';
import { SignDto } from '../model/sign/sign-dto';
import { UserService } from './user.service';


@Injectable()
export class ExtraService {

    constructor(private http: Http, private customHttp: HttpInterceptor
      , private jwtService: JwtService, private userService: UserService, private router: Router) {}

    /**
     * 상품 이미지 만들기 (포스터 만들기)
     */
    makeProductImage(formData: FormData) {
      return this.customHttp.post(environment.imageUrl + '/images/extra/productImage', formData);
    }

    /**
     * 프로필 이미지 등록
     */
    makeProfileImage(file) {
      const formData = new FormData();
      formData.append('file', file);

      return this.customHttp.post(environment.imageUrl + '/images/extra/profile', formData);
    }

    /**
     * 서명 이미지 만들기
     */
    makeSignature(signDto: SignDto) {
      return this.customHttp.post(environment.imageUrl + '/images/extra/signImage', signDto);
    }

    /**
     * 서명 이미지 조회
     */
    getSignImage(signNo: number) {
      return this.customHttp.get(environment.imageUrl + '/images/extra/sign/' + signNo);
    }

    /**
     * 서명 이미지 상태 조회
     */
    getSignImageStatus(signNo: number) {
      return this.http.get(environment.imageUrl + '/images/extra/sign/' + signNo + '/status', {
        headers : this.userService.getHeadersFromSession()
      });
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/api/extra.service.ts